<template>
<div>

<ClickEditInputText  :title="phrase.original" :value="phrase.translations[0].translation" valkey="phrase.translations[0].id" @dataChanged="dataChanged"></ClickEditInputText>

</div>
</template>

<script>
export default {

  name: 'SelectedPhrases',
  props:["phrase"],
  data () {
    return {

    }
  },
  computed:{
  	phrasewatch()
  	{
  		return this.phrase
  	}
  },
  watch:{
  	phrasewatch(newVal,oldVal)
  	{
  		console.log("phrasewatch");
  		console.log(newVal);
  	}
  },
  methods:{
  	 dataChanged(data)
    {
    	if(data.value !== this.phrase.translations[0].translation)
    	{
    		let formdata = new FormData()
	    	formdata.append("translation",data.value)
	    	formdata.append("language_id",this.phrase.translations[0].language_id)    	
	    	this.generalSubmission(formdata,"language/update_phrase_translation/"+this.phrase.translations[0].id,this.afterdataChanged)
    	}
    	else
    	{

    	}
    	
    },
    afterdataChanged(response)
    {
    	console.log("data changed");
    	console.log(response);
    	if(response.data.status && response.data.status !==200)
    	{
    		
    	}
    	else
    	{    		
    		this.$emit("phraseUpdated",response.data)
    	}
    	
    },

  }
};
</script>

<style lang="css" scoped>
</style>